export default __webpack_public_path__ + "static/media/attribute.a629766e.svg";